import axios from 'axios'
import lstModules from 'common/json/lstModules.json'
var tokenid = localStorage.getItem('tokenid')
var httpURL = lstModules['ptm'].url + ':' + lstModules['ptm'].port

const getPtmPlanSettingSvc = (ptmId, cb) => {
    var status = 'Success'
    var obj = { status: status, message: '' }
    axios({
        url: httpURL + '/sms/ptm/setting/list',
        method: 'POST',
        params: { ptmId: ptmId },
        headers: { tokenid: tokenid },
        withCredentials: true
    })
        .then(response => {
            if (response.data.SvcStatus === 'Success') {
                obj.message = ''
                obj.status = 'Success'
                obj.lstPtmSetting = response.data.lstPtmSetting
                cb(obj)
            } else {
                obj.status = 'Failure'
                obj.message = response.data.SvcMsg
                cb(obj)
            }
        })
        .catch(error => {
            obj.status = 'Exception'
            obj.message = error
            cb(obj)
        })
}
const savePtmSettingSvc = (lstPtmSetting, cb) => {
    var status = 'Success'
    var obj = { status: status, message: '' }
    var formData = new FormData()
    formData.append("lstPtmSetting", JSON.stringify(lstPtmSetting));
    axios({
        url: httpURL + '/sms/ptm/setting/save',
        method: 'POST',
        data: formData,
        headers: { tokenid: tokenid },
        withCredentials: true
    })
        .then(response => {
            if (response.data.SvcStatus === 'Success') {
                obj.message = response.data.SvcMsg
                obj.status = 'Success'
                cb(obj)
            } else {
                obj.status = 'Failure'
                obj.message = response.data.SvcMsg
                cb(obj)
            }
        })
        .catch(error => {
            obj.status = 'Exception'
            obj.message = error
            cb(obj)
        })
}
const getAllRoomSvc = (cb) => {
    var status = 'Success'
    var obj = { status: status, message: '' }
    axios({
        url: httpURL + '/sms/a/building/rooms/list_all',
        method: 'POST',
        params: {},
        headers: { tokenid: tokenid },
        withCredentials: true
    })
        .then(response => {
            if (response.data.SvcStatus === 'Success') {
                obj.message = response.data.SvcMsg
                obj.status = 'Success'
                obj.lstRoom = response.data.lstBuildingRooms
                // console.log(response)
                cb(obj)
            } else {
                obj.status = 'Failure'
                obj.message = response.data.SvcMsg
                cb(obj)
            }
        })
        .catch(error => {
            obj.status = 'Exception'
            obj.message = error
            cb(obj)
        })
}

const getTchRoomListSvc = (cb) => {
    var status = 'Success'
    var obj = { status: status, message: '' }
    axios({
        url: httpURL + '/sms/ptm/room/list',
        method: 'POST',
        params: {},
        headers: { tokenid: tokenid },
        withCredentials: true
    })
        .then(response => {
            if (response.data.SvcStatus === 'Success') {
                obj.message = ''
                obj.status = 'Success'
                obj.lstPtmRoom = response.data.lstPtmRoom
                cb(obj)
            } else {
                obj.status = 'Failure'
                obj.message = response.data.SvcMsg
                cb(obj)
            }
        })
        .catch(error => {
            obj.status = 'Exception'
            obj.message = error
            cb(obj)
        })
}
const saveTchRoomSvc = (tchRoomId, tchId, roomId, cb) => {
    // console.log("saveTchRoomSvc() called.. ")
    var status = 'Success'
    var obj = { status: status, message: '' }

    axios({
        url: httpURL + '/sms/ptm/room/save',
        method: 'POST',
        params: { tchRoomId: tchRoomId, tchId: tchId, roomId: roomId },
        headers: { tokenid: tokenid },
        withCredentials: true
    })
        .then(response => {
            if (response.data.SvcStatus === 'Success') {
                obj.message = response.data.SvcMsg
                obj.status = 'Success'
                cb(obj)
            } else {
                obj.status = 'Failure'
                obj.message = response.data.SvcMsg
                cb(obj)
            }
        })
        .catch(error => {
            obj.status = 'Exception'
            obj.message = error
            cb(obj)
        })
}
const removeTchRoomSvc = (tchRoomId, cb) => {
    // console.log("removeTchRoomSvc() called.. ")
    var status = 'Success'
    var obj = { status: status, message: '' }

    axios({
        url: httpURL + '/sms/ptm/room/remove',
        method: 'POST',
        params: { tchRoomId: tchRoomId },
        headers: { tokenid: tokenid },
        withCredentials: true
    })
        .then(response => {
            if (response.data.SvcStatus === 'Success') {
                obj.message = response.data.SvcMsg
                obj.status = 'Success'
                cb(obj)
            } else {
                obj.status = 'Failure'
                obj.message = response.data.SvcMsg
                cb(obj)
            }
        })
        .catch(error => {
            obj.status = 'Exception'
            obj.message = error
            cb(obj)
        })
}
const removeAllTchSvc = (cb) => {
    // console.log("removeAllTchSvc() called.. ")
    var status = 'Success'
    var obj = { status: status, message: '' }

    axios({
        url: httpURL + '/sms/ptm/room/remove_all',
        method: 'POST',
        params: {},
        headers: { tokenid: tokenid },
        withCredentials: true
    })
        .then(response => {
            if (response.data.SvcStatus === 'Success') {
                obj.message = response.data.SvcMsg
                obj.status = 'Success'
                cb(obj)
            } else {
                obj.status = 'Failure'
                obj.message = response.data.SvcMsg
                cb(obj)
            }
        })
        .catch(error => {
            obj.status = 'Exception'
            obj.message = error
            cb(obj)
        })
}
export { getPtmPlanSettingSvc, savePtmSettingSvc, getTchRoomListSvc, getAllRoomSvc, saveTchRoomSvc, removeTchRoomSvc, removeAllTchSvc }